import {StreamComponentType} from '@Components/ai-chat-window/lib/stream-component-registry.types';
import {defineStreamComponentRegistration} from '@Components/ai-chat-window/lib/stream-component-registration';
import type {ButtonGroupSkeletonProps} from './button-group-skeleton.types';
import {SKELETON_BUTTON_WIDTHS} from './button-group-skeleton.types';
import {ButtonGroupSkeleton} from './button-group-skeleton';

function parseButtonWidths(value: unknown): string[] {
  if (!Array.isArray(value) || value.length === 0 || !value.every((width) => typeof width === 'string')) {
    return SKELETON_BUTTON_WIDTHS;
  }

  return value;
}

export const buttonGroupSkeletonRegistration = defineStreamComponentRegistration(
  StreamComponentType.BUTTON_GROUP_SKELETON,
  ButtonGroupSkeleton,
  (props: Record<string, unknown>): ButtonGroupSkeletonProps => ({
    buttonWidths: parseButtonWidths(props.buttonWidths),
  })
);
